import React from 'react';
import { connect, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { formValueSelector } from 'redux-form';
import ShipmentDetailsSection from './ShipmentDetailsSection';
import { jobDetailsForm } from '../../constants/FormConstants';
import { change } from 'redux-form';
import { bindActionCreators } from 'redux';

const ShipmentDetailsContainer = (props) => {
  const { jobLocations, updatedArea,onSelectArea,jobType } = props;
  //const state = useSelector((state)=>state)
  const currentJob = useSelector((state) => state.currentJob);
  const areaId = currentJob?currentJob.areaId:null
  const areas = useSelector((state) => state.referenceData.areas);
  const vessels = useSelector((state) => state.referenceData.vessels);

  const formValues = useSelector((state) => state.form.jobDetailsForm);//useSelector((state) => formValueSelector(jobDetailsForm)(state));
  //const formValues = useSelector((state) => formValueSelector(jobDetailsForm)(state, 'fieldName1', 'fieldName2'));


  const clientCode = formValues.clientCode || (currentJob ? currentJob.clientCode : null);

  return (
    <ShipmentDetailsSection
      {...props}
     jobType={jobType}
      clientCode={clientCode}
      jobLocations={jobLocations}
      onSelectArea={onSelectArea}
      updatedArea={updatedArea}
      currentJob={currentJob}
      areaId={areaId}
      areas={areas}
      vessels={vessels}
      referenceData={props.referenceData} // Pass any other props needed
      actions={props.actions} 
      //initialValues= {props.initialValues}
    />
  );
};
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ change }, dispatch),
});

const mapStateToProps = (state) => ({
  referenceData: state.referenceData,
});

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentDetailsContainer);
